(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/init.js');

'use strict';

svs.numbergames.game_app.app.start({
  Router: svs.keno.Router,
  product: svs.numbergames.productMapping.CONSTANTS.KENO
});

 })(window);